// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"123":"0ec0a5ab","581":"c2f38ee0"}[chunkId] + ".chunk.css";
};